/**
 * Types for POST /api/v1/services/convertCoordinates only.
 * Do not reuse Work services catalog types (/api/v1/work/services).
 */

/**
 * @typedef {'auto' | 'wgs84' | 'utm' | 'etm' | 'dms'} ConvertSourceSystem
 */

/**
 * @typedef {'coordinates' | 'file'} ConvertInputSource
 */

/**
 * @typedef {'csv' | 'xlsx' | 'json' | 'geojson' | 'kml' | 'kmz' | 'zip' | null} ConvertFileType
 */

/**
 * @typedef {Object} ConvertCoordinateInput
 * @property {string} [name]
 * @property {number} [latitude]
 * @property {number} [longitude]
 * @property {number} [utm_east]
 * @property {number} [utm_north]
 * @property {string} [utm_zone]
 * @property {number} [etm_east]
 * @property {number} [etm_north]
 * @property {string} [etm_zone]
 * @property {string} [dms_latitude]
 * @property {string} [dms_longitude]
 * @property {number} [x]
 * @property {number} [y]
 */

/**
 * @typedef {Object} ConvertCoordinatesJsonRequest
 * @property {ConvertSourceSystem} [source_system]
 * @property {string} [utm_zone]
 * @property {ConvertCoordinateInput[]} coordinates
 */

/**
 * @typedef {Object} ConvertedCoordinate
 * @property {number|null} index
 * @property {string|null} name
 * @property {number|null} x
 * @property {number|null} y
 * @property {number|null} latitude
 * @property {number|null} longitude
 * @property {number|null} utm_east
 * @property {number|null} utm_north
 * @property {string|null} utm_zone
 * @property {number|null} etm_east
 * @property {number|null} etm_north
 * @property {string|null} etm_zone
 * @property {string|null} dms_latitude
 * @property {string|null} dms_longitude
 * @property {'lat_lon'|'utm'|'etm'|string|null} coordinate_system
 */

/**
 * @typedef {Object} ConvertFailedRow
 * @property {number} index
 * @property {Record<string, unknown>} input
 * @property {string} error
 */

/**
 * @typedef {Object} ConvertCoordinatesSummary
 * @property {number} total
 * @property {number} converted
 * @property {number} failed
 */

/**
 * @typedef {Object} ConvertCoordinatesData
 * @property {ConvertInputSource} source
 * @property {ConvertFileType} file_type
 * @property {ConvertedCoordinate[]} coordinates
 * @property {ConvertFailedRow[]} failed
 * @property {ConvertCoordinatesSummary} summary
 */

/**
 * @typedef {Object} ConvertCoordinatesResponse
 * @property {true} success
 * @property {string} message
 * @property {ConvertCoordinatesData} data
 * @property {{ timestamp: string, version?: string }} meta
 */

export const CONVERT_COORDINATES_ENDPOINT = '/services/convertCoordinates'

export const MAX_COORDINATES = 5000
export const MAX_FILE_BYTES = 20 * 1024 * 1024

export const ALLOWED_FILE_EXTENSIONS = [
  'csv',
  'txt',
  'xlsx',
  'xls',
  'json',
  'geojson',
  'kml',
  'kmz',
  'zip',
]

export const SOURCE_SYSTEMS = ['auto', 'wgs84', 'utm', 'etm', 'dms']
